import getApiClient from "../../../../shared/api";

export const FETCH_STORYBOARD = "FETCH_STORYBOARD";
export const SAVE_STORYBOARD_SETTINGS = "SAVE_STORYBOARD_SETTINGS";
export const DOWNLOAD_STORYBOARD = "DOWNLOAD_STORYBOARD";
export const CLEAR_DOWNLOAD_STORYBOARD = "CLEAR_DOWNLOAD_STORYBOARD";
export const RESET_DOWNLOAD_STORYBOARD = "RESET_DOWNLOAD_STORYBOARD";

export const fetchStoryboard = (filmId) => {
    return (dispatch) => {
        dispatch({
            type: FETCH_STORYBOARD,
            payload: getApiClient().get(`/film/${filmId}/storyboard`)
        });
    };
}

export const saveStoryboardSettings = (filmId, settings) => {
    return (dispatch) => {
        dispatch({
            type: SAVE_STORYBOARD_SETTINGS,
            payload: getApiClient().put(`/film/${filmId}/storyboard/settings`, settings)
        });
    };
}

export const downloadStoryboard = (filmId, settings) => {
    return (dispatch) => {
        dispatch({
            type: DOWNLOAD_STORYBOARD,
            payload: getApiClient().post(`/film/${filmId}/storyboard/download`, { settings })
        });
    };
}

export const pdfDownloaded = () => {
    return (dispatch) => {
        dispatch({
            type: CLEAR_DOWNLOAD_STORYBOARD,
            meta: {}
        });
    };
}

export const resetPdf = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_DOWNLOAD_STORYBOARD,
            meta: {}
        });
    };
}
